'use strict';

import $ from 'jquery';
import { isValidImageSize, isValidImageType } from '@/js/modules/file_validation';
import { onPageLoad } from '@/js/modules/page_load';
import { extractItemIds, prepareImagePreview, stripFileName } from '@/js/modules/uploads';

// display failed upload files
const displayFailedUploads = (failedFiles, formEl) => {
  const message = `${failedFiles} image(s) failed. Please upload images smaller than 10MB.`;

  if (document.body.hasAttribute('data-sidenav-layout')) {
    formEl
      .find('.ui--flash')
      .each((_, flash) =>
        flash.dispatchEvent(new CustomEvent('flash:show', { detail: { message, level: 'error' } }))
      );
  } else {
    formEl.find('.flash').html(message).removeClass('hide');
  }
};

function initializeJsUploader() {
  if ($('.js-uploader').length) {
    $(document).on('click', '.uploader__delete-image', function (event) {
      event.preventDefault();

      const $jsUploader = $(this).closest('.js-uploader');
      const kind = $jsUploader.data().kind;
      let $parent;
      if (kind === 'project-inspiration') {
        $parent = $(this).closest('.project-images');
      } else {
        $parent = $jsUploader;
      }

      const $li = $(this).closest('li');
      const url = $(this).data().deleteUrl;

      if (!$li.hasClass('uploader__thumb--loading')) {
        $li.addClass('uploader__thumb--loading');

        $.post(url, { _method: 'delete' }).done(() => {
          $li.remove();
          extractItemIds($parent);
        });
      }
    });

    $('.js-uploader').each(function () {
      const $form = $(this);
      const kind = $form.data('kind');
      const $parent = $form;
      let loadingFilesCount = 0;
      let max = 100;
      if (parseInt($form.data('max'), 10) > 0) {
        max = parseInt($form.data('max'), 10);
      }

      $form.bind('click', function () {
        if (document.body.hasAttribute('data-sidenav-layout')) {
          $form
            .find('.ui--flash')
            .each((_, flash) => flash.dispatchEvent(new CustomEvent('flash:hide')));
        } else {
          $form.find('.flash').addClass('hide');
        }
      });
      $form.bind('dragover', function () {
        $(this).addClass('uploader--hover');
      });
      $form.bind('dragleave', function () {
        $(this).removeClass('uploader--hover');
      });
      $form.bind('fileuploadsubmit', function (e, data) {
        const $uploader = $(e.target);
        data.formData = {
          kind,
        };
        const boardId = $uploader.data('board-id');
        if (boardId) {
          data.formData.board_id = boardId;
        }
        const projectId = $uploader.data('project-id');
        if (projectId) {
          data.formData.project_id = projectId;
        }
        const projectQuestionnaireId = $uploader.data('project-questionnaire-id');
        if (projectQuestionnaireId) {
          data.formData.project_questionnaire_id = projectQuestionnaireId;
        }
        const commentId = $uploader.data('comment-id');
        if (commentId) {
          data.formData.comment_id = commentId;
        }

        const customQuestionId = $uploader.data('custom-question-id');
        if (customQuestionId) {
          data.formData.custom_question_id = customQuestionId;
        }

        const tabName = $uploader.data('tab-name');
        if (tabName) {
          data.formData.tabName = tabName;
        }
      });

      let failedUploads = 0;
      let filesCount;

      $form.fileupload({
        url: '/items',
        dataType: 'json',
        sequentialUploads: true,
        maxNumberOfFiles: 2,
        dropZone: $form,
        change(e, data) {
          failedUploads = 0;
          filesCount = data.files.length;
        },
        add(e, data) {
          const file = data.files[0];
          // ignore non-image files
          if (!isValidImageType(file.name)) {
            return false;
          }
          $form.removeClass('uploader--hover');

          // ignore image bigger than 10MB
          if (!isValidImageSize(file)) {
            failedUploads += 1;
            // in case all files are bigger than 10MB
            if (failedUploads === filesCount) {
              displayFailedUploads(failedUploads, $form);
            }

            return;
          }

          file.uploadName = stripFileName(file.name);

          const reader = new FileReader();
          reader.onload = function (event) {
            if ($('.uploader__thumb', $form).length + loadingFilesCount <= max) {
              // prepare a preview of image *before* it gets processed on the server
              // to ensure smooth experience for the user
              prepareImagePreview(event.target.result, file.name, 88).then((imgData) => {
                if (imgData) {
                  const $li = $(
                    `<li class="uploader__thumb uploader__thumb--loading" data-file-id="${file.uploadName}"><img src="${imgData}"/><span/></li>`
                  );
                  $('.uploader__thumbs', $form).append($li);
                  loadingFilesCount -= 1;
                  data.submit();
                } else {
                  alert(
                    'Invalid image. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file.'
                  );
                }
              });
            } else {
              loadingFilesCount -= 1;
            }
          };
          reader.readAsDataURL(file);
        },
        done(e, data) {
          if (data.result.error) {
            failedUploads += 1;
            const fileId = data.result.name;
            $(`.uploader__thumb--loading[data-file-id="${fileId}"]`, $form).remove();
          } else {
            const image = data.result;
            const fileId = image.name;
            const $loading = $(`.uploader__thumb--loading[data-file-id="${fileId}"]`, $form);
            const $link = $(
              `<div data-delete-url="${image.delete_url}" class="uploader__delete-image" data-item-id="${image.id}"><span/><img src="${image.thumbnail}"></div>`
            );

            $loading.data('id', image.id).find('img').remove();
            $loading.append($link).data('file-id', null).removeClass('uploader__thumb--loading');
            if ($('#project_updated_at')) {
              // make sure notifications are created in case clients only upload images on project form
              $('#project_updated_at').val(new Date());
            }
          }

          extractItemIds($parent);
        },
        start(e) {
          if (failedUploads > 0) {
            displayFailedUploads(failedUploads, $form);
          }

          failedUploads = 0;
        },
        stop(e) {
          if (failedUploads > 0) {
            displayFailedUploads(failedUploads, $form);
          }
        },
      });
    });
  }
}

onPageLoad(() => {
  $(function () {
    initializeJsUploader();
  });
});
